import { useMemo } from "react"
import { useScaleApplication } from "@/domains/application/use-scale-application"
import { LcAddress } from "@/domains/core"

export const useMinimalPool = (minimalPoolAddress: string | undefined) => {
  const scaleApp = useScaleApplication()
  const minimalPool = useMemo(() => {
    if (!minimalPoolAddress) {
      return null
    }
    const found = scaleApp.MinimalPools.Repository.find(new LcAddress(minimalPoolAddress))
    return found ?? undefined
  }, [minimalPoolAddress, scaleApp.MinimalPools.Repository.totalPools])

  return minimalPool
}
